import { render, staticRenderFns } from "./NewArticles.vue?vue&type=template&id=2b203c38&scoped=true&"
import script from "./NewArticles.vue?vue&type=script&lang=js&"
export * from "./NewArticles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b203c38",
  null
  
)

export default component.exports